import { FaUser, FaUserCheck } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { MdOutlineGroups, MdPreview } from "react-icons/md";
import {
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  styled,
} from "@mui/material";

const REGISTRATION_STEP = ["Sarana", "Pemilik", "Staff", "Pratinjau", "Akun"];

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 18,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#3b82f6",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#3b82f6",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#d8d8d8",
    borderRadius: 1,
  },
}));

const CustomStepperIcon = (props) => {
  const { icon, active, completed } = props;

  const icons = {
    1: <IoLocationOutline className="w-full h-full" />,
    2: <FaUser className="w-full h-full" />,
    3: <MdOutlineGroups className="w-full h-full" />,
    4: <MdPreview className="w-full h-full" />,
    5: <FaUserCheck className="w-full h-full" />,
  };

  return (
    <div className={`w-[36px] h-[36px]`}>
      <div
        className={`w-full h-full rounded-full flex justify-center items-center text-white p-2 ${
          active || completed ? "bg-blue-500" : "bg-gray-300"
        }`}
      >
        {icons[String(icon)]}
      </div>
    </div>
  );
};

const RegisterPharmacyStepper = ({ activeStep }) => {
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      connector={<ColorlibConnector />}
    >
      {REGISTRATION_STEP.map((label, i) => (
        <Step key={label}>
          <StepLabel
            // slots={{
            //   stepIcon: CustomStepperIcon,
            // }}
            StepIconComponent={CustomStepperIcon}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default RegisterPharmacyStepper;
